
  import {
    eventStates,
    getEventStatus
  } from "../../../../_helpers/eventTypesStates";
  import EventDx from "../../../../models/deliveryexperience/EventDx";
  import StageDx from "../../../../models/deliveryexperience/StageDx";

  export default {
    name: "TimelineItemStatus",
    props: {
      item: {
        type: [EventDx, StageDx],
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        eventStates: eventStates
      };
    },
    computed: {
      statusOptions() {
        const itemStatus = this.item.getBaseline.status;
        const startDate = this.item.getBaseline.startDate;
        var statusOptions = [];
        statusOptions = Object.values(eventStates).filter(states => {
          if (itemStatus == eventStates.pendingToOccur.name) {
            return states.name == eventStates.cancelled.name;
          }
          if (itemStatus == eventStates.pendingToConfirm.name) {
            return (
              states.name == eventStates.cancelled.name ||
              states.name == eventStates.occurred.name
            );
          }
          if (itemStatus == eventStates.occurred.name) {
            return states.name == eventStates.cancelled.name;
          }
          if (itemStatus == eventStates.cancelled.name) {
            if (new Date(startDate) < new Date())
              return states.name == eventStates.occurred.name;
            else return states.name == eventStates.pendingToOccur.name;
          }
          return false;
        });
        return statusOptions;
      }
    },
    methods: {
      async selectOption(status: String) {
        var itemBaseline = this.item.getBaseline;
        itemBaseline.status = status;
        await this.putEventDxBaseline({
          baseline: itemBaseline,
          eventId: this.item.getId
        });
      },
      getItemStatus(status) {
        return getEventStatus(status);
      }
    }
  };
